import { render } from "./ModalEditInput.vue?vue&type=template&id=1b594f41&ts=true"
import script from "./ModalEditInput.vue?vue&type=script&lang=ts"
export * from "./ModalEditInput.vue?vue&type=script&lang=ts"

import "./ModalEditInput.vue?vue&type=style&index=0&id=1b594f41&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__